import React from "react";
import { useHistory, useParams } from "react-router-dom";
import firebaseApi from "../../apis/firebaseApi";
import { FrameContext } from "../../contexts/FrameContext";
import dateHelpers from "../../helpers/dateHelpers";

const EditAppointment = () => {
    const {scheduleId} = useParams();
    let {companyId } = React.useContext(FrameContext);
    const [schedule, setSchedule] = React.useState();
    let history = useHistory();

    React.useEffect(() => {
        firebaseApi.getCompanySchedule(companyId, scheduleId, data => {
            setSchedule({ ...data.data(), id: data.id });
        });
    }, [companyId, scheduleId]);

    const onCancelAppointment = () => {
        history.push(`/appointment/${scheduleId}/cancel`);
    }

    if (!schedule) return null;

    return (
        <div className="pf-schedule-edit-appointment">
            <div className="pf-schedule-form-group border">
                <label>Customer Name</label>
                <div>{schedule.user.name}</div>
            </div>
            <div className="pf-schedule-form-group border">
                <label>Date</label>
                <div>{dateHelpers.getScheduleDay(new Date(schedule.schedule.startTime * 1000), "en")}</div>
            </div>
            <div className="pf-schedule-form-group border">
                <label>Time</label>
                <div>{dateHelpers.getTimeString(new Date(schedule.schedule.startTime * 1000), true)} - {dateHelpers.getTimeString(new Date(schedule.schedule.endTime * 1000), true)}</div>
            </div>
            <div className="text-center mt-20">
                <button onClick={onCancelAppointment} className="cts-cancel-btn"><i className="fas fa-times" /> Cancel Appointment</button>
            </div>
        </div>
    )
}

export default EditAppointment;